import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { PLANS, PlanTier } from "@/contexts/SubscriptionContext";

const planOrder: { tier: PlanTier; popular: boolean; desc: string }[] = [
  { tier: "starter", popular: false, desc: "Perfect for small businesses and freelancers" },
  { tier: "professional", popular: true, desc: "Best for growing businesses with CA collaboration" },
  { tier: "enterprise", popular: false, desc: "For large organizations needing full control" },
];

const PricingSection = () => {
  return (
    <section className="py-20 lg:py-28 bg-muted/50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-accent/10 text-accent mb-4">
            Pricing
          </span>
          <h2 className="text-3xl md:text-4xl font-bold font-display text-foreground mb-4">
            Simple, Transparent Pricing
          </h2>
          <p className="text-lg text-muted-foreground">
            Start free for 4 months. No credit card required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {planOrder.map((item, i) => {
            const plan = PLANS[item.tier];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className={`relative p-8 rounded-xl bg-card border transition-all ${
                  item.popular
                    ? "border-accent shadow-elevated scale-105"
                    : "border-border shadow-card"
                }`}
              >
                {item.popular && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-semibold bg-accent text-accent-foreground">
                    Most Popular
                  </span>
                )}
                <h3 className="text-xl font-bold font-display text-foreground mb-1">{plan.name}</h3>
                <p className="text-sm text-muted-foreground mb-6">{item.desc}</p>
                <div className="mb-6">
                  <span className="text-4xl font-bold font-display text-foreground">{plan.priceLabel}</span>
                  <span className="text-muted-foreground">/month</span>
                </div>
                <Link to="/dashboard">
                  <Button
                    className={`w-full mb-6 ${
                      item.popular
                        ? "bg-accent text-accent-foreground hover:bg-accent/90"
                        : ""
                    }`}
                    variant={item.popular ? "default" : "outline"}
                  >
                    Start Free Trial
                  </Button>
                </Link>
                <ul className="space-y-3">
                  {plan.features.map((f, j) => (
                    <li key={j} className="flex items-center gap-2 text-sm text-foreground">
                      <Check className="h-4 w-4 text-accent flex-shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
